module.exports = __webpack_public_path__ + "img/25.f79717b6.png";